import { Button, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const StyledDeleteButton = styled(Button)(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));

export const StyledFormWrap = styled('div')({
  margin: 'auto',
  maxWidth: '600px',

  '& .titleContainer': {
    maxWidth: 'none',
  },
  '& .initialFiles > div': {
    width: '100%',
  },
});

export const StyledFileWrap = styled('div')(({ theme }) => ({
  position: 'relative',
  margin: theme.spacing(1),
}));

export const StyledVideoDelete = styled(IconButton)((props) => {
  const { theme } = props;
  return {
    position: 'absolute',
    right: 10,
    top: 10,
    zIndex: 100,
    backgroundColor: theme.palette.grey[600],
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.action.disabledBackground,
    },
  };
});
